(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name webAgro1App.GraficoProdutividade
   * @description
   * # GraficoProdutividade
   * Service in the webAgro1App.
   */
  angular
    .module('webAgro1App')
    .factory('GraficoProdutividade', GraficoProdutividadeService);

  /**
   * GraficoProdutividadeService dependencies
   */
  GraficoProdutividadeService.$inject = [
    '$http',
    '$q',
    'googleChartApiPromise'
  ];

  /**
   * GraficoProdutividadeService declaration
   */
  // eslint-disable-next-line max-lines-per-function, max-params
  function GraficoProdutividadeService($http, $q, googleChartApiPromise) {
    //////////////////////////////////////////
    // Service data
    const colors = {
      corMedia: '#008000',
      corAzul: '#4169E1',
      corCinza: '#C0C0C0',
      corVermelho: '#FF6347',
      semCor: '*',
      textSacas: '* Sacas de 60Kg'
    };
    const EMPTY = 'empty';

    //////////////////////////////////////////
    // Service declaration
    const service = {
      createChartObject: CreateChartObject,
      chart: {
        safras: ChartSafras,
        glebasPorSafra: ChartGlebasPorSafra,
        cultivar: ChartCultivar,
        glebas: ChartGlebas
      }
    };
    return service;

    //////////////////////////////////////////
    // Function declarations
    function convertUnidade(value, unidade) {
      if (unidade.conversao) {
        return value * unidade.conversao;
      }
      return value;
    }

    function round(value) {
      return Math.floor(value * 10) / 10;
    }

    function CreateChartObject() {
      return {
        cat: null,
        options: {
          title: null,
          colors: [],
          vAxis: {
            minValue: 0
          },
          tooltip: { isHtml: true }
        },
        type: 'ColumnChart',
        data: {
          cols: [],
          rows: []
        },
        legend: []
      };
    }

    // eslint-disable-next-line max-lines-per-function
    function ChartSafras(filter) {
      const chart = service.createChartObject();

      chart.cat = 'por_safra';
      chart.options.title = 'Histórico de Produtividade';
      chart.options.colors = [colors.corAzul, colors.corCinza];
      chart.options.legend = { position: 'none' };
      chart.options.chartArea = {
        width: '90%',
        height: '80%'
      };

      chart.legend = [
        {
          color: {
            backgroundColor: colors.corAzul
          },
          text: {
            content: `Produtividade - ${informationDescription(filter)} `
          }
        },
        {
          color: {
            backgroundColor: colors.corMedia
          },
          text: {
            content: `Médias - ${informationDescription(filter)}`
          }
        },
        {
          color: {
            backgroundColor: 'white'
          },
          text: {
            content: informationDescription(filter) === 'Sc/ha' ? colors.textSacas : ''
          }
        }
      ];

      const dataArray = [
        ['Data', `Produtividade - ${informationDescription(filter)}`, { role: 'annotation' }, { role: 'style' }]
      ];
      if (filter.melhor_media) {
        const diffCol = [
          '% Dif. Produtividade e Melhor Produtividade', { role: 'annotation' }
        ];
        dataArray[0] = dataArray[0].concat(diffCol);

        chart.legend.splice(1, 0, {
          color: {
            backgroundColor: colors.corCinza
          },
          text: {
            content: 'Dif. Produtividade e Melhor Produtividade - %',
            style: {
              fontSize: '12px'
            }
          }
        });
      }

      // eslint-disable-next-line max-lines-per-function
      return $q(function(resolve, reject) {
        $http.get(`${SERVER}v1/produtividade/chart_por_safra`, {
          params: filterParameters(filter)
        // eslint-disable-next-line max-lines-per-function, complexity
        }).then(function(result) {
          if (!result.data || result.data.length === 0) {
            reject(EMPTY);
            return;
          }

          googleChartApiPromise.then(function() {
            const dataTable = google.visualization.arrayToDataTable(result.data);

            chart.data = dataTable;
            resolve(chart);
          });
        })
          .catch(function(error) {
            reject(error);
            console.error(error);
          });
      });
    }

    // eslint-disable-next-line max-lines-per-function, complexity
    function ChartGlebasPorSafra(filter) {
      const chart = service.createChartObject();

      chart.cat = 'comparativo_glebas';
      chart.options.title = 'Comparativo Entre Talhões';
      chart.options.chartArea = {
        width: '80%',
        height: '80%',
        left: 50,
        top: 40
      };
      delete chart.options.colors;

      const dataArray = [
        ['Comparação']
      ];

      // eslint-disable-next-line max-lines-per-function, complexity
      return $q(function(resolve, reject) {
        $http.get(`${SERVER}v1/produtividade/comparativo_glebas`, {
          params: filterParameters(filter)
        // eslint-disable-next-line max-lines-per-function
        }).then(function(result) {
          function invalidData(data) {
            let areaTotal = 0;
            for (const key in data) {
              areaTotal += data[key].area_total_ha;
            }
            return (!!data && data.length !== 0 && !areaTotal);
          }

          if (invalidData(result.data)) {
            reject(EMPTY);
            return;
          }

          function convertData(data) {
            for (const key in data) {
              const safras = data[key].safras.map((safra) => ({
                ...safra,
                media: convertUnidade(safra.media, filter.unidade)
              }));

              data[key] = {
                ...data[key],
                safras
              };
            }
            return data;
          }

          const data = convertData(result.data);

          [
            [`Melhor (${data.melhor.area_total_ha})`, data.melhor.safras],
            [`25% Superior (${data.superiores.area_total_ha})`, data.superiores.safras],
            [`50% Intermediário (${data.intermediarias.area_total_ha})`, data.intermediarias.safras],
            [`25% Inferior (${data.inferiores.area_total_ha})`, data.inferiores.safras],
            ['Média', data.medias.safras]
          ].forEach(function(series) {
            generateBar(series[1], series[0]);
          });

          googleChartApiPromise.then(function() {
            const dataTable = google.visualization.arrayToDataTable(dataArray);

            chart.data = dataTable;
            resolve(chart);
          });

          function generateBar(safras, label) {
            const y = [label];
            for (let i = 0; i < safras.length; i++) {
              const calc = round(Number(safras[i].media));
              y.push(calc);
              y.push(calc);

              const series = `${safras[i].safra_descricao} - ${informationDescription(filter)}`;
              if (!dataArray[0].includes(series)) {
                dataArray[0] = dataArray[0].concat([
                  series, { role: 'annotation' }
                ]);
              }
            }

            dataArray.push(y);
          }
        })
          .catch(function(error) {
            reject(error);
          });
      });
    }

    // eslint-disable-next-line max-lines-per-function
    function ChartCultivar(filter) {
      const chart = service.createChartObject();

      chart.cat = 'por_cultivar';
      chart.options.title = 'Produtividade por Cultivar';
      chart.options.colors = [
        colors.corAzul,
        '#000000'
      ];
      chart.options.chartArea = {
        top: 40,
        height: '75%',
        width: '70%'
      };
      chart.type = 'ComboChart';
      chart.options.seriesType = 'bars';
      chart.options.series = {
        1: {
          type: 'line'
        }
      };
      chart.legend = [

      ];

      // eslint-disable-next-line max-lines-per-function
      return $q(function(resolve, reject) {
        $http.get(`${SERVER}v1/produtividade/chart_por_cultivar`, {
          params: filterParameters(filter)
        // eslint-disable-next-line max-lines-per-function
        }).then(function(result) {
          if (!result.data || result.data.length === 0) {
            reject(EMPTY);
            return;
          }

          const dataTable = google.visualization.arrayToDataTable(result.data);

          chart.data = dataTable;
          resolve(chart);
        })
          .catch(function(error) {
            reject(error);
            console.error(error);
          });
      });
    }

    // eslint-disable-next-line max-lines-per-function
    function ChartGlebas(filter) {
      const chart = service.createChartObject();

      chart.cat = 'por_gleba';
      chart.options.title = 'Produtividade por Talhão';
      chart.options.chartArea = {
        top: 40,
        left: 120,
        height: '75%',
        width: '85%'
      };
      chart.type = 'ComboChart';
      chart.options.seriesType = 'bars';
      chart.options.series = {
        1: {
          type: 'line'
        }
      };
      chart.options.legend = {
        position: 'none'
      };
      chart.options.colors = [
        '#000000'
      ];
      chart.legend = [
        {
          color: {
            backgroundColor: colors.corAzul
          },
          text: {
            content: `Superiores - ${informationDescription(filter)}`
          }
        },
        {
          color: {
            backgroundColor: colors.corCinza
          },
          text: {
            content: `Intermediárias - ${informationDescription(filter)}`
          }
        },
        {
          color: {
            backgroundColor: colors.corVermelho
          },
          text: {
            content: `Inferiores - ${informationDescription(filter)}`
          }
        },
        {
          color: {
            backgroundColor: colors.corMedia
          },
          text: {
            content: `Médias - ${informationDescription(filter)}`
          }
        },
        {
          color: {
            backgroundColor: 'white'
          },
          text: {
            content: informationDescription(filter) === 'Sc/ha' ? colors.textSacas : ''
          }
        }
      ];

      const dataArray = [
        ['Talhão', `Produtividade ${informationDescription(filter)}`, { role: 'annotation' }, { role: 'style' }]
      ];

      if (filter.safra_inicial.id !== filter.safra_final.id) {
        dataArray[0] = dataArray[0].concat(['Quantidade de Safras', { role: 'annotation' }, { role: 'tooltip' }]);
        chart.legend.splice(4, 0, {
          color: {
            backgroundColor: '#000',
            height: '2px'
          },
          text: {
            content: 'Quantidade de Safras'
          }
        });
      }

      // eslint-disable-next-line max-lines-per-function
      return $q(function(resolve, reject) {
        $http.get(`${SERVER}v1/produtividade/chart_por_gleba`, {
          params: filterParameters(filter)
        // eslint-disable-next-line max-lines-per-function, complexity
        }).then(function(result) {
          if (!result.data || result.data.length === 0) {
            reject(EMPTY);
            return;
          }

          googleChartApiPromise.then(function() {
            const dataTable = google.visualization.arrayToDataTable(result.data);

            chart.data = dataTable;
            resolve(chart);
          });
        })
          .catch(function(error) {
            reject(error);
            console.error(error);
          });
      });
    }

    function filterParameters(filter) {
      const propriedadesIds = _.map(filter.propriedades, 'id');

      return {
        safra_inicial: filter.safra_inicial.data_inicial,
        safra_final: filter.safra_final.data_inicial,
        atividade: filter.atividade.id,
        periodo: _.get(filter, 'periodo.codigo'),
        propriedade: propriedadesIds.join(),
        data_inicial: filter.dataInicial ? moment(filter.dataInicial).format(MOMENT_DATE_ENGLISH_FORMAT) : null,
        data_final: filter.dataFinal ? moment(filter.dataFinal).format(MOMENT_DATE_ENGLISH_FORMAT) : null,
        informacao: (filter.informacao || {}).id,
        conversao: (filter.unidade || {}).conversao
      };
    }

    function informationDescription(filters) {
      return filters.informacao.id === 'atr_medio' ? 'ATR/ha' : filters.unidade.abreviatura;
    }
  }
}());
